import ContextManagerService from "../services/contextManagerService";
import { setSessionItem } from "../services/sessionManagerService";

const SESSION_CONTEXT_CATEGORY = "context_Category";
const SESSION_CONTEXT_PAGE = "context_PageKey";
// const SESSION_CONTEXT_DATA = 'context_DATA';

// context event payload should contain the following elements
// payload  {
//       eventKey -- name of the event being triggered
//       etc...  any key value data that we want to pass
//       for the event to use when consuming
//  }
//

export default function contextEventHandler(payload) {
  if (payload) {
    const { eventKey } = payload;
    switch (eventKey.toLowerCase()) {
      case "pageload":
        pageLoadEvent();
        break;
      default:
        break;
    }
  } else {
    // default assume that this is called on page load
    pageLoadEvent();
  }
  return true;
}

function pageLoadEvent() {
  const locationData = readLocationData();
  const reportData = readReportingData(locationData.host, locationData.pathname);
  const { channelId } = reportData;
  const mappedData = getServiceMappings(channelId, locationData, reportData);
  updatePageContext(mappedData);
}

// Update the Session Context page and Category
function updatePageContext(mappedData) {
  setSessionItem(SESSION_CONTEXT_CATEGORY, mappedData.categoryId);
  setSessionItem(SESSION_CONTEXT_PAGE, mappedData.pageKey);
}

function readReportingData(hostName, pathname) {
  const reportingData = window.reportingData;
  let channelId = "";
  let currentPageData = [];

  if (reportingData != null) {
    const { currentPage, sitePlatform, siteplatform } = reportingData;

    let platform = "";
    if (siteplatform !== undefined || siteplatform != null) {
      platform = siteplatform;
    } else if (sitePlatform !== undefined || sitePlatform != null) {
      platform = sitePlatform;
    }

    if (platform !== undefined && (platform !== "" || platform !== null)) {
      channelId = platform;
      if (channelId === "dotcom") {
        channelId = "COM";
      }
    }
    if (currentPage !== undefined && currentPage != null) {
      currentPageData = currentPage.split(":");
    }
  }

  if (channelId === "") {
    if (hostName.includes("onlinebanking")) {
      channelId = "OLB";
    } else if (hostName.includes("onboarding")) {
      channelId = "APPLY";
    } else if (hostName.includes("usbank.com")) {
      channelId = "COM";
    } else if (pathname.includes("pcsp")) {
      channelId = "PTA";
    }
  }

  return {
    channelId,
    currentPageData,
    rawReportData: reportingData,
  };
}

function readLocationData() {
  const urlLocationData = window.location;
  const response = {};

  if (urlLocationData != null) {
    const { href, origin, host } = urlLocationData;
    const pathname = href.replace(origin, "");
    const rawPath = href;

    response.origin = origin;
    response.rawPath = rawPath;
    response.pathname = pathname;

    let hostValue = host;
    const hostComps = hostValue.split("-");
    if (hostComps.length > 1) {
      // if the path contains more than one item after the hyphen then strip off the hyphen
      // and return host as the rest of the path.
      hostValue = hostComps[1];
    }
    response.host = hostValue;

    let newPathName = pathname;
    if (pathname.startsWith("/")) {
      const pathNameLength = pathname.length;
      newPathName = pathname.slice(1, pathNameLength);
    }

    const pathComps = newPathName.split("/");
    const length = pathComps.length;
    if (length > 1) {
      response.pathComponents = pathComps;
    }
  }

  return response;
}

function removeHTMLTag(originalValue) {
  if (originalValue != null) {
    let newValue = originalValue.toLowerCase().replace(".html", "");
    if (newValue !== "") {
      return newValue;
    }
  }
  return originalValue;
}

function getDefaultMap(locationData) {
  const { pathComponents } = locationData;
  let tempCategory = "DEFAULT";

  let length = 0;
  if (pathComponents != null) {
    length = pathComponents.length;
  }
  let tempPageKey = "";
  if (length > 0) {
    // all mapped data is based off of the URL from the pageKey.
    tempPageKey = removeHTMLTag(pathComponents[length - 1]);
  }

  if (tempPageKey !== "") {
    // all mapped data is based off of the URL from the pageKey.
    switch (tempPageKey.toLowerCase()) {
      default:
        const startIndex = findStartIndex(pathComponents);
        tempCategory = removeHTMLTag(pathComponents[startIndex]).toUpperCase();
        break;
    }
  } else {
    tempPageKey = tempCategory;
  }

  return {
    categoryId: tempCategory,
    pageKey: tempPageKey,
  };
}

function getServiceMappings(channelId, locationData, reportData) {
  const { categoryId, pageKey } = getDefaultMap(locationData);
  let tempCategory = categoryId;
  let tempPageKey = pageKey;

  const service = new ContextManagerService(channelId);
  const serviceMappingObj = service.Process(locationData.pathname, pageKey, reportData);
  if (serviceMappingObj != null) {
    if (serviceMappingObj.categoryId != null) {
      tempCategory = serviceMappingObj.categoryId;
    }
    if (serviceMappingObj.pageKey != null) {
      tempPageKey = serviceMappingObj.pageKey;
    }
  }
  return {
    categoryId: tempCategory,
    pageKey: tempPageKey,
  };
}

function findStartIndex(pathComponents) {
  const length = pathComponents.length;
  let startIndex = 0;
  for (let index = 0; index < length; index++) {
    if (pathComponents[index] !== "") {
      startIndex = index;
      break;
    }
  }
  return startIndex;
}
